import React from "react";
import { RiShieldUserLine } from "react-icons/ri";

export const NotAuthorized = () => {
  return (
    <div className="container py-8 max-w-4xl">
      <div className="rounded-xl p-6 border-2 border-destructive bg-card">
        <div className="flex flex-col space-y-4">
          <div className="flex items-center gap-2">
            <RiShieldUserLine className="w-5 h-5 text-destructive" />
            <h2 className="text-xl font-semibold">Not Authorized</h2>
          </div>
          <p className="text-muted-foreground">
            You do not have permission to access the admin panel. Please contact
            your administrator if you believe this is an error.
          </p>
        </div>
      </div>
    </div>
  );
};
